// src/components/clubs/EditCompetitionPage.js
import React, { useState, useEffect, useRef } from 'react';
// Firebase importok
// FIGYELEM: Mivel a fájl a components/clubs mappában van, 
// két szintet (../../) kell visszalépni a firebase.js-ig!
import { db, auth } from '../../firebase'; 
import { collection, serverTimestamp, doc, getDoc, updateDoc } from 'firebase/firestore';
import { useParams, useNavigate } from 'react-router-dom';
import { FiCheckCircle, FiPlus, FiMapPin } from 'react-icons/fi';
import { useMapsLibrary } from '@vis.gl/react-google-maps'; // ÚJ IMPORT
import GoogleMapPicker from '../GoogleMapPicker';

//KOROSZTÁLY ADATOK
const ageCategoryOptions = [
    { value: '', label: 'Válasszon korosztályt...' },
    { value: 'all', label: 'Összes korosztály' }, // Ez került a tetejére
    { value: 'mini', label: 'mini (5-9)' },
    { value: 'gyerek', label: 'gyerek (10-12)' },
    { value: 'junior', label: 'Junior (13-14)' },
    { value: 'kadet', label: 'Kadét (15-17)' },
    { value: 'fiatal_felnott', label: 'fiatal felnőtt (18-20)' },
    { value: 'felnott', label: 'felnőtt (21-54)' },
    { value: 'veteran', label: 'veterán (55-99)' }
];

// KATEGÓRIA ADATOK
const categoryMappings = {
  '3d': [
    { value: '', label: 'Válasszon 3D íjkategóriát...' },
    { isGroupLabel: true, label: 'HDH-IAA' },
    { value: '3d_hdh_bb', label: 'BB (Barebow)' },
    { value: '3d_hdh_bg', label: 'BG (Fúvócső)' },
    { value: '3d_hdh_cb', label: 'CB (Csigás Barebow)' },
    { value: '3d_hdh_crb', label: 'CRB (Számszerij)' },
    { value: '3d_hdh_cu', label: 'CU (Scope-os Csigás)' },
    { value: '3d_hdh_hu', label: 'HU (Vadász Csigás)' },
    { value: '3d_hdh_ol', label: 'OL (Olimpiai)' },
    { value: '3d_hdh_pbhb', label: 'PBHB (Tradi)' },
    { value: '3d_hdh_trlb', label: 'TRLB (Longbow)' },
    { value: '3d_hdh_trrb', label: 'TRRB (Vadászreflex)' },
    { isGroupLabel: true, label: 'IFAA' },
    { value: '3d_ifaa_bbc', label: 'BB(C) (Barebow-Csigás)' },
    { value: '3d_ifaa_bbr', label: 'BB(R) (Barebow-Reflex)' },
    { value: '3d_ifaa_bhc', label: 'BH(C) (Vadászijász-Csigás)' },
    { value: '3d_ifaa_bhr', label: 'BH(R) (Vadászijász-Reflex)' },
    { value: '3d_ifaa_bl', label: 'BL (Korlátozott Vadászijász)' },
    { value: '3d_ifaa_bu', label: 'BU (Korlátlan Vadászijász)' },
    { value: '3d_ifaa_fsc', label: 'FS(C) (Korl. nyílt o.-Csigás)' },
    { value: '3d_ifaa_fsr', label: 'FS(R) (Korl. nyílt o.-Reflex)' },
    { value: '3d_ifaa_fu', label: 'FU (Korlátlan nyílt osztály)' },
    { value: '3d_ifaa_hb', label: 'HB (Történelmi íj)' },
    { value: '3d_ifaa_hbm', label: 'HB(M) (Történelmi íj modern)' },
    { value: '3d_ifaa_lb', label: 'LB (Longbow)' },
    { value: '3d_ifaa_tr', label: 'TR (Tradicionális reflex)' }
  ],
    'terep': [
    { value: '', label: 'Válasszon terep kategóriát...' },
    { value: 'terep_olimpiai', label: 'OL (Olimpiai)' },
    { value: 'terep_csigas', label: 'CU (Scope-os Csigás)' },
    { value: 'terep_barebow', label: 'BB (Barebow)' },
    { value: 'terep_cb', label: 'CB (Csigás Barebow)' },
    { value: 'terep_hu', label: 'HU (Vadász Csigás)' },
    { value: 'terep_pbhb', label: 'PBHB (Tradi - Pusztai íj)' },
    { value: 'terep_trlb', label: 'TRLB (Longbow)' },
    { value: 'terep_trrb', label: 'TRRB (Vadászreflex)' }
  ],
    'palya': [
    { value: '', label: 'Válasszon pálya kategóriát...' },
    { isGroupLabel: true, label: 'WA (World Archery)' },
    { value: 'palya_wa_ol', label: 'R (Olimpiai reflexíj)' },
    { value: 'palya_wa_cu', label: 'CU (Scope-os Csigás)' },
    { value: 'palya_wa_hu', label: 'HU (Vadász Csigás)' },
    { value: 'palya_wa_bb', label: 'B (Barebow)' },
    { value: 'palya_wa_trrb', label: 'TRRB (Vadászreflex)' },
    { value: 'palya_wa_trlb', label: 'TRLB (Longbow)' },
    { value: 'palya_wa_pbhb', label: 'PBHB (Tradi - Pusztai íj)' },
    { value: 'palya_wa_crb', label: 'CRB (Számszeríj)' }, // ÚJ: Számszeríj hozzáadva
    { isGroupLabel: true, label: 'IFAA' },
    { value: 'palya_ifaa_fu', label: 'FU (Freestyle Unlimited)' },
    { value: 'palya_ifaa_fsr', label: 'FSR (Freestyle Ltd Recurve)' },
    { value: 'palya_ifaa_fsc', label: 'FSC (Freestyle Ltd Compound)' },
    { value: 'palya_ifaa_bbr', label: 'BBR (Barebow Recurve)' },
    { value: 'palya_ifaa_bbc', label: 'BBC (Barebow Compound)' },
    { value: 'palya_ifaa_bu', label: 'BU (Bowhunter Unlimited)' },
    { value: 'palya_ifaa_bl', label: 'BL (Bowhunter Limited)' },
    { value: 'palya_ifaa_bhc', label: 'BHC (Bowhunter Compound)' },
    { value: 'palya_ifaa_bhr', label: 'BHR (Bowhunter Recurve)' },
    { value: 'palya_ifaa_lb', label: 'LB (Longbow)' },
    { value: 'palya_ifaa_hb', label: 'HB (Historical Bow)' },
    { value: 'palya_ifaa_tr', label: 'TR (Traditional Bow)' }
  ],
    'tortenelmi': [
    { value: '', label: 'Válasszon történelmi kategóriát...' },
    { value: 'tortenelmi_pusztai_modern', label: 'Modern pusztai íj' },
    { value: 'tortenelmi_pusztai_termeszetes', label: 'Természetes pusztai íj' },
    { value: 'tortenelmi_botij', label: 'Történelmi hosszúíj / Botíj' },
    { value: 'tortenelmi_vadaszij', label: 'Hagyományos vadászíj' },
    { value: 'tortenelmi_szamszerij', label: 'Történelmi számszeríj' },
    { value: 'tortenelmi_bb', label: 'BB (Barebow - Vendég kategória)' }, // ÚJ: BB hozzáadva
  ],
    'oromijasz': [
    { value: '', label: 'Válasszon örömijász kategóriát...' },
    { value: 'orom_wa_ol', label: 'OL (Olimpiai reflexíj)' },
    { value: 'orom_wa_cu', label: 'CU (Scope-os Csigás)' },
    { value: 'orom_wa_hu', label: 'HU (Vadász Csigás)' },
    { value: 'orom_wa_cb', label: 'CB (Csigás Barebow)' },
    { value: 'orom_wa_bb', label: 'BB (Barebow)' },
    { value: 'orom_wa_trrb', label: 'TRRB (Vadászreflex)' },
    { value: 'orom_wa_trlb', label: 'TRLB (Longbow)' },
    { value: 'orom_wa_pbhb', label: 'PBHB (Pusztai íj)' },
    { value: 'orom_wa_crb', label: 'CRB (Számszeríj)' },
    { value: 'orom_wa_bg', label: 'BG (Fúvócső)' } // ÚJ: Fúvócső hozzáadva
  ],
  'egyeb': [
    { value: '', label: 'Válasszon egyéb kategóriát...' },
    { value: 'egyeb_wa_ol', label: 'OL (Olimpiai reflexíj)' },
    { value: 'egyeb_wa_cu', label: 'CU (Scope-os Csigás)' },
    { value: 'egyeb_wa_hu', label: 'HU (Vadász Csigás)' },
    { value: 'egyeb_wa_cb', label: 'CB (Csigás Barebow)' },
    { value: 'egyeb_wa_bb', label: 'BB (Barebow)' },
    { value: 'egyeb_wa_trrb', label: 'TRRB (Vadászreflex)' },
    { value: 'egyeb_wa_trlb', label: 'TRLB (Longbow)' },
    { value: 'egyeb_wa_pbhb', label: 'PBHB (Pusztai íj)' },
    { value: 'egyeb_wa_crb', label: 'CRB (Számszeríj)' },
    { value: 'egyeb_wa_bg', label: 'BG (Fúvócső)' }, // ÚJ: Fúvócső hozzáadva
    { value: 'egyeb_altalanos', label: 'Egyéb Általános' }
  ]
};

const scoringValueOptions = [
  { value: '', label: 'Érték hozzáadása...' },
  ...Array.from({ length: 21 }, (_, i) => ({ value: i.toString(), label: i.toString() })),
  { value: 'X', label: 'X' }
];

const tieBreakingOptions = [
    { value: '', label: 'Válasszon szabályt...' },
    { value: 'shoot_off', label: 'Szétlövés' },
    { value: 'fewer_zeros', label: 'Kevesebb 0' },
    { value: 'more_elevens_xs', label: 'Több 11/X' },
    { value: 'custom', label: 'Egyéb (leírás alább)'}
];

const initialFormData = { // Alapértelmezett állapot a form ürítéséhez
    creationType: 'full_event',
    format: 'normal',
    competitionName: '',
    competitionType: '',
    isInternational: false,
    categories: [],
    ageCategories: [], // Ez a sor hiányzott, most hozzáadva
    competitionDate: '',
    startDate: '',
    endDate: '',
    registrationDeadline: '',
    allowRegistrationChanges: false,
    competitionPermitRequired: false,
    registrationChangeDeadline: '',
    location: '',
    gpsLatitude: '',
    gpsLongitude: '',
    organizingClub: '',
    inMISZCalendar: false,
    lunchAvailable: false,
    lunchInEntryFee: false,
    lunchPrice: '',
    maxParticipants: 999,
    numberOfTeams: '',
    numberOfTargets: '',
    shotsPerTarget: '',
    crossbowSingleShot: false,
    scoringValues: [],
    tieBreakingRule: '',
    customTieBreakingRule: '',
    warningMessage: '',
    competitionDescription: ''
};

const EditCompetitionPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const locationInputRef = useRef(null); // ÚJ REF
  const places = useMapsLibrary('places'); // GOOGLE PLACES

  // --- ÁLLAPOTOK (Mindent ide a tetejére tettem, töröld a máshol lévőket!) ---
  const [formData, setFormData] = useState(null); // Szerkesztésnél null-ról indítjuk
  const [currentCategoryOptions, setCurrentCategoryOptions] = useState([]);
  const [categoryToPotentiallyAdd, setCategoryToPotentiallyAdd] = useState('');
  const [scoreValueToPotentiallyAdd, setScoreValueToPotentiallyAdd] = useState('');
  const [ageCategoryToPotentiallyAdd, setAgeCategoryToPotentiallyAdd] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showCustomScoreModal, setShowCustomScoreModal] = useState(false);
  const [customScoreInput, setCustomScoreInput] = useState('');

  // --- ÚJ: HELYSZÍN AUTOCOMPLETE LOGIKA ---
  useEffect(() => {
    if (!places || !locationInputRef.current) return;

    const options = {
      fields: ['geometry', 'name', 'formatted_address'],
      componentRestrictions: { country: 'hu' }
    };

    const autocomplete = new places.Autocomplete(locationInputRef.current, options);

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (place && place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        setFormData(prev => ({
          ...prev,
          location: place.formatted_address || place.name,
          gpsLatitude: lat.toFixed(6),
          gpsLongitude: lng.toFixed(6)
        }));
      }
    });

    return () => {
      const pacContainers = document.querySelectorAll('.pac-container');
      pacContainers.forEach(container => {
        if (container) container.remove();
      });
    };
  }, [places]);

  // --- ADATOK BETÖLTÉSE ---
  useEffect(() => {
    const fetchCompetitionData = async () => {
      if (!id) return;
      try {
        const docRef = doc(db, "events", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setFormData(data); // Beletesszük a régi adatokat a formba
          
          if (data.competitionType && categoryMappings[data.competitionType]) {
            setCurrentCategoryOptions(categoryMappings[data.competitionType]);
          }
        } else {
          alert("A verseny nem található!");
          navigate('/egyesulet-dashboard');
        }
      } catch (error) {
        console.error("Hiba a betöltéskor:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompetitionData();
  }, [id, navigate]);


// --- 5. PONT: STÍLUS SEGÉDLET (Ide került be) ---
  const scoreButtonStyle = (isSelected) => ({
    width: '42px',
    height: '42px',
    borderRadius: '6px',
    border: isSelected ? '1px solid #b30000' : '1px solid #ccc',
    backgroundColor: isSelected ? '#b30000' : 'white',
    color: isSelected ? 'white' : '#333',
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.15s ease',
    fontSize: '1rem'
  });

  const competitionTypeOptions = [
    { value: '', label: 'Válasszon típust...' },
    { value: '3d', label: '3D' },
    { value: 'terep', label: 'Terep' },
    { value: 'palya', label: 'Pálya' },
    { value: 'tortenelmi', label: 'Történelmi' },
    { value: 'oromijasz', label: 'Örömijász' },
    { value: 'egyeb', label: 'Egyéb' }
  ];

    

  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData(prevFormData => {
      const newFormData = { ...prevFormData };

      if (name === "competitionType") {
        newFormData.competitionType = value;
        newFormData.categories = [];
        setCategoryToPotentiallyAdd('');

        if (value && categoryMappings[value]) {
          setCurrentCategoryOptions(categoryMappings[value]);
        } else {
          setCurrentCategoryOptions([]);
        }
      } else if (type === 'checkbox') {
        newFormData[name] = checked;
      } else {
        newFormData[name] = value;
      }
      if (name === "tieBreakingRule" && value !== "custom") {
        newFormData.customTieBreakingRule = '';
      }
      return newFormData;
    });
  };

  const handleCategorySelectionChange = (event) => {
    const selectedValue = event.target.value;
    setCategoryToPotentiallyAdd(selectedValue);

    if (selectedValue && selectedValue !== '') {
      if (!formData.categories.includes(selectedValue)) {
        setFormData(prevFormData => ({
          ...prevFormData,
          categories: [...prevFormData.categories, selectedValue]
        }));
      }
    }
  };

  const handleRemoveCategory = (categoryValueToRemove) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      categories: prevFormData.categories.filter(catVal => catVal !== categoryValueToRemove)
    }));
    if (categoryToPotentiallyAdd === categoryValueToRemove) {
        setCategoryToPotentiallyAdd('');
    }
  };

const handleAgeSelectionChange = (event) => {
    const selectedValue = event.target.value;
    
    if (selectedValue === 'all') {
        // Kivesszük az összes létező értéket (kivéve az üreset és az 'all'-t)
        const allAges = ageCategoryOptions
            .map(opt => opt.value)
            .filter(val => val !== '' && val !== 'all');
            
        setFormData(prevFormData => ({
            ...prevFormData,
            ageCategories: allAges // Mindenki bekerül
        }));
        setAgeCategoryToPotentiallyAdd(''); // Visszaállítjuk a választót
    } else if (selectedValue && selectedValue !== '') {
        // Normál, egyesével történő hozzáadás
        setAgeCategoryToPotentiallyAdd(selectedValue);
        if (!formData.ageCategories.includes(selectedValue)) {
            setFormData(prevFormData => ({
                ...prevFormData,
                ageCategories: [...prevFormData.ageCategories, selectedValue]
            }));
        }
    }
};

  const handleScoreValueSelectionChange = (event) => {
    const selectedValue = event.target.value;
    setScoreValueToPotentiallyAdd(selectedValue);

    if (selectedValue && selectedValue !== '') {
      if (!formData.scoringValues.includes(selectedValue)) {
        setFormData(prevFormData => ({
          ...prevFormData,
          scoringValues: [...prevFormData.scoringValues, selectedValue]
        }));
      }
    }
  };

      const toggleScoringValue = (val) => {
    setFormData(prev => {
      const current = prev.scoringValues;
      const next = current.includes(val)
        ? current.filter(v => v !== val)
        : [...current, val].sort((a, b) => {
            if (a === 'X') return 1;
            if (b === 'X') return -1;
            return parseInt(a) - parseInt(b);
          });
      return { ...prev, scoringValues: next };
    });
  };

  const handleAddCustomScore = () => {
    if (customScoreInput.trim() !== '') {
      toggleScoringValue(customScoreInput.trim());
      setCustomScoreInput('');
      setShowCustomScoreModal(false);
    }
  };

const handleRemoveAgeCategory = (valueToRemove) => {
    setFormData(prevFormData => ({
        ...prevFormData,
        ageCategories: prevFormData.ageCategories.filter(val => val !== valueToRemove)
    }));
    // Ha épp ki volt választva a legördülőben, alaphelyzetbe rakjuk
    setAgeCategoryToPotentiallyAdd('');
};

  const handleNumericChange = (e) => {
    const { name, value } = e.target;
    if (value === '' || /^[0-9\b]+$/.test(value)) {
      setFormData(prevState => ({ ...prevState, [name]: value }));
    }
  };

    const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // --- VALIDÁCIÓK ---
    if (!formData.competitionType) {
        alert('Kérjük, válassza ki a verseny típusát!');
        setIsSubmitting(false);
        return;
    }
    const hasActualSelectableCategories = currentCategoryOptions &&
                                          currentCategoryOptions.some(cat => cat.value !== '' && !cat.isGroupLabel);
    if (hasActualSelectableCategories && formData.categories.length === 0) {
        alert('Kérjük, válasszon ki legalább egy íjkategóriát!');
        setIsSubmitting(false);
        return;
    }

    if (formData.ageCategories.length === 0) {
        alert('Kérjük, válasszon ki legalább egy korosztályt!');
        setIsSubmitting(false);
        return;
    }

    if (formData.scoringValues.length === 0) {
        alert('Kérjük, adjon meg legalább egy találati értéket!');
        setIsSubmitting(false);
        return;
    }
    if (formData.tieBreakingRule === '') {
        alert('Kérjük, válasszon pontegyenlőségi szabályt!');
        setIsSubmitting(false);
        return;
    }
    if (formData.tieBreakingRule === 'custom' && formData.customTieBreakingRule.trim() === '') {
        alert('Kérjük, adja meg az egyedi pontegyenlőségi szabály leírását!');
        setIsSubmitting(false);
        return;
    }

    const currentUser = auth.currentUser;
    if (!currentUser) {
        alert('A mentéshez be kell jelentkeznie!');
        setIsSubmitting(false);
        return;
    }

    // --- ADATOK ELŐKÉSZÍTÉSE SZERKESZTÉSHEZ ---
    const dataToSend = {
        ...formData,
        // Itt NEM állítjuk be az organizerId-t és a createdAt-et, mert azok már megvannak
        // Itt NEM állítjuk be a participantsCount-ot 0-ra, hogy ne vesszenek el a nevezők!
        updatedAt: serverTimestamp(), // Csak egy frissítési dátumot adunk hozzá
        effectiveTieBreakingRule: formData.tieBreakingRule === 'custom' ? formData.customTieBreakingRule : formData.tieBreakingRule,
    };

    if (formData.tieBreakingRule !== 'custom') {
        dataToSend.customTieBreakingRule = ""; // Ürítjük, ha nem egyedi szabály van
    }

    try {
        // addDoc(collection(...)) HELYETT updateDoc(doc(...))
        // Ez garantálja, hogy csak a meglévő versenyt módosítjuk az ID alapján
        const docRef = doc(db, "events", id);
        await updateDoc(docRef, dataToSend);
        
        console.log("Esemény sikeresen frissítve!");
        setShowSuccessModal(true);
        // Itt nem kell üríteni a formot, mert a mentés sikeres volt.

    } catch (error) {
        console.error("Hiba történt a frissítés közben: ", error);
        alert(`Hiba történt a mentés közben: ${error.message}`);
    } finally {
        setIsSubmitting(false);
    }
};


  const pageStyle = { padding: '2rem 1rem', fontFamily: 'Arial, sans-serif', margin: '2rem 0', backgroundColor: '#f0f2f5', minHeight: 'calc(100vh - 4rem)' };
  const cardStyle = { backgroundColor: '#ffffff', padding: '2rem', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', width: '100%', boxSizing: 'border-box' };
  const formContainerStyle = { display: 'flex', flexDirection: 'row', gap: '2rem' };
  const leftColumnStyle = { flex: 1, display: 'flex', flexDirection: 'column' };
  const rightColumnStyle = { flex: 1, display: 'flex', flexDirection: 'column' };
  const headingStyle = { color: '#b30000', textAlign: 'center', marginBottom: '2rem' };
  const labelStyle = { fontWeight: 'bold', marginBottom: '0.3rem', display: 'block' };
  const inputStyle = { padding: '0.7rem', borderRadius: '4px', border: '1px solid #ccc', width: '100%', boxSizing: 'border-box', backgroundColor: 'white' };
  const checkboxLabelStyle = { display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: 'normal', cursor: 'pointer' };
  const radioGroupStyle = { display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap', marginBottom: '1rem' };
  const formSectionGroupStyle = { display: 'flex', flexDirection: 'column', gap: '1.2rem' };
  const sectionTitleStyle = { fontSize: '1.3rem', color: '#333', borderBottom: '1px solid #ddd', paddingBottom: '0.5rem', marginBottom: '1rem' };
  const descriptionTextAreaStyle = { ...inputStyle, minHeight: 'calc(100% - 3rem)', height: 'auto', resize: 'vertical', flexGrow: 1 };
  const submitButtonStyle = { ...inputStyle, backgroundColor: '#b30000', color: 'white', fontWeight: 'bold', cursor: 'pointer', marginTop: '1.5rem' };
  const disabledOptionCommentStyle = { color: '#777', fontStyle: 'italic', marginLeft: '0.5rem', fontSize: '0.9em' };
  const disabledLabelStyle = { ...checkboxLabelStyle, opacity: 0.6, cursor: 'not-allowed' };
  const optgroupLabelStyle = { fontWeight: 'bold', fontStyle: 'italic', color: '#333' };
  const modalOverlayStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000,
    backdropFilter: 'blur(3px)'
  };
  const formRowStyle = { 
    display: 'flex', 
    alignItems: 'center', 
    gap: '1.5rem', 
    marginBottom: '1rem' 
  };
  
  const inlineLabelStyle = { 
    fontWeight: 'bold', 
    minWidth: '200px', // Ettől lesznek egy vonalban a mezők
    marginBottom: 0 
  };

  const modalContentStyle = {
    backgroundColor: 'white', padding: '30px', borderRadius: '16px', textAlign: 'center', maxWidth: '400px', width: '90%',
    boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
  };

  
const modalOkButtonStyle = { 
    backgroundColor: '#b30000', color: 'white', border: 'none', padding: '12px 40px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer'
  };
  

  // EZT SZÚRD BE:
  const modalCancelButtonStyle = {
    backgroundColor: '#eee', color: '#333', border: 'none', padding: '12px 24px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer'
  };

  const highlightedCheckboxStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    backgroundColor: '#fff9c4', // Halvány arany háttér
    padding: '0.4rem 0.8rem',
    borderRadius: '6px',
    border: '1px solid #fbc02d',
    fontSize: '0.85rem',
    fontWeight: 'bold',
    color: '#5f4b00',
    cursor: 'pointer',
    transition: '0.2s'
  };

  const renderCategoryOptions = () => {
    if (!formData.competitionType && currentCategoryOptions.length === 0) {
      return <option value="" disabled>Először válasszon verseny típust!</option>;
    }
    if (formData.competitionType && (!currentCategoryOptions || currentCategoryOptions.filter(opt => opt.value !== '').length === 0)) {
        return <option value="" disabled>Nincs elérhető kategória ehhez a típushoz</option>;
    }

    let elements = [];
    let currentOptgroupLabel = null;
    let optgroupOptions = [];

    const placeholderOption = currentCategoryOptions.find(opt => opt.value === '');
    if (placeholderOption) {
        elements.push(
            <option key="cat_placeholder" value="" disabled={categoryToPotentiallyAdd !== ""}>
                {placeholderOption.label}
            </option>
        );
    }

    currentCategoryOptions.forEach((item) => {
      if (item.value === '') return;

      if (item.isGroupLabel) {
        if (currentOptgroupLabel && optgroupOptions.length > 0) {
          elements.push(
            <optgroup label={currentOptgroupLabel} key={currentOptgroupLabel} style={optgroupLabelStyle}>
              {optgroupOptions}
            </optgroup>
          );
        }
        currentOptgroupLabel = item.label;
        optgroupOptions = [];
      } else {
        const isAlreadySelected = formData.categories.includes(item.value);
        const optionElement = (
          <option
            key={item.value}
            value={item.value}
            disabled={isAlreadySelected}
          >
            {item.label}{isAlreadySelected ? " (már hozzáadva)" : ""}
          </option>
        );
        if (currentOptgroupLabel) {
          optgroupOptions.push(optionElement);
        } else {
          elements.push(optionElement);
        }
      }
    });

    if (currentOptgroupLabel && optgroupOptions.length > 0) {
      elements.push(
        <optgroup label={currentOptgroupLabel} key={currentOptgroupLabel} style={optgroupLabelStyle}>
          {optgroupOptions}
        </optgroup>
      );
    }

    const allSelectableCategoriesAdded = formData.competitionType && currentCategoryOptions.filter(opt => opt.value !== '' && !opt.isGroupLabel).every(opt => formData.categories.includes(opt.value));
    if (elements.length <= 1 && allSelectableCategoriesAdded && formData.competitionType) {
        if (elements.length === 0 || (elements.length === 1 && elements[0].props.value === '')) {
             elements.push(<option value="" disabled>Minden kategória hozzáadva</option>);
        }
    }
    return elements;
  };

  if (loading) return <div style={pageStyle}><h2 style={headingStyle}>Betöltés...</h2></div>;
  if (!formData) return null;

  

    return (
    <div style={pageStyle}>
      {/* SIKER MODAL */}
      {showSuccessModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <FiCheckCircle size={50} color="#28a745" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Sikeres mentés!</h3>
            <p style={{ color: '#666', marginBottom: '25px' }}>
              A verseny módositása sikeresen megtörtént.
            </p>
            <button 
              style={modalOkButtonStyle} 
               onClick={() => {
                setShowSuccessModal(false);
                navigate('/egyesulet-dashboard');
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {/* EGYEDI PONTSZÁM MODAL */}
      {showCustomScoreModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={{ margin: '0 0 15px 0' }}>Egyedi pontszám</h3>
            <p style={{ color: '#666', marginBottom: '15px' }}>Írd be a pontszámot (pl. 24):</p>
            <input 
              type="text" 
              value={customScoreInput}
              onChange={(e) => setCustomScoreInput(e.target.value)}
              style={{ ...inputStyle, textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' }}
              autoFocus
            />
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowCustomScoreModal(false)}>Mégse</button>
              <button style={modalOkButtonStyle} onClick={handleAddCustomScore}>Hozzáadás</button>
            </div>
          </div>
        </div>
      )}

      <h1 style={headingStyle}>Verseny Szerkesztése / Adminisztrációja</h1>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>

        {/* --- 1. SOR: ALAPBEÁLLÍTÁSOK + LEÍRÁS --- */}
        <div style={{ display: 'flex', flexDirection: 'row', gap: '2rem' }}>

          <div style={leftColumnStyle}>
            <div style={cardStyle}>
              <div style={formSectionGroupStyle}>
                <div style={sectionTitleStyle}>Általános Beállítások</div>
                <div>
                  <label style={labelStyle}>Létrehozás típusa:</label>
                  <div style={radioGroupStyle}>
                    <label style={checkboxLabelStyle}>
                      <input type="radio" name="creationType" value="full_event" checked={formData.creationType === 'full_event'} onChange={handleChange} />
                      Nevezéssel együtt
                    </label>
                    <label style={disabledLabelStyle}>
                      <input type="radio" name="creationType" value="announcement_only" checked={formData.creationType === 'announcement_only'} onChange={handleChange} disabled />
                      Csak versenykiírás
                    </label>
                  </div>
                </div>
                <div>
                  <label style={labelStyle}>Formátum:</label>
                  <div style={radioGroupStyle}>
                    <label style={checkboxLabelStyle}>
                      <input type="radio" name="format" value="normal" checked={formData.format === 'normal'} onChange={handleChange} />
                      Normál
                    </label>
                    <label style={checkboxLabelStyle}>
                      <input type="radio" name="format" value="multi_day_distance" checked={formData.format === 'multi_day_distance'} onChange={handleChange} />
                      Több nap/táv
                    </label>
                  </div>
                </div>

                <div style={{ ...formRowStyle, alignItems: 'flex-start' }}>
                  <label htmlFor="competitionName" style={{ ...inlineLabelStyle, marginTop: '10px' }}>Verseny neve:</label>
                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
                    <input type="text" id="competitionName" name="competitionName" value={formData.competitionName} onChange={handleChange} style={inputStyle} required />
                    <label style={highlightedCheckboxStyle}>
                      <input type="checkbox" name="isInternational" checked={formData.isInternational} onChange={handleChange} />
                      Nemzetközi verseny
                    </label>
                  </div>
                </div>

                <div style={formRowStyle}>
                  <label htmlFor="competitionType" style={inlineLabelStyle}>Verseny típusa:</label>
                  <div style={{ flex: 1 }}>
                    <select id="competitionType" name="competitionType" value={formData.competitionType} onChange={handleChange} style={inputStyle} required >
                      {competitionTypeOptions.map(option => (
                        <option key={option.value} value={option.value} disabled={option.value === ''}>{option.label}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div style={formRowStyle}>
                  <label htmlFor="category_selector" style={inlineLabelStyle}>Íjkategória hozzáadása:</label>
                  <div style={{ flex: 1 }}>
                    <select id="category_selector" value={categoryToPotentiallyAdd} onChange={handleCategorySelectionChange} style={inputStyle}
                      disabled={!formData.competitionType || currentCategoryOptions.length === 0}>
                      {renderCategoryOptions()}
                    </select>
                  </div>
                </div>
                {formData.categories.length > 0 && (
                  <div style={{ paddingLeft: '200px', display: 'flex', flexWrap: 'wrap', gap: '5px', marginBottom: '1rem' }}>
                    {formData.categories.map(cat => (
                      <span key={cat} style={{ background: '#e9ecef', padding: '2px 8px', borderRadius: '10px', fontSize: '0.85em', border: '1px solid #dee2e6' }}>
                        {cat} <button type="button" onClick={() => handleRemoveCategory(cat)} style={{ border: 'none', color: '#dc3545', background: 'none', cursor: 'pointer' }}>×</button>
                      </span>
                    ))}
                  </div>
                )}

                <div style={formRowStyle}>
                  <label htmlFor="age_category_selector" style={inlineLabelStyle}>Korosztály hozzáadása:</label>
                  <div style={{ flex: 1 }}>
                    <select id="age_category_selector" value={ageCategoryToPotentiallyAdd} onChange={handleAgeSelectionChange} style={inputStyle}>
                      {ageCategoryOptions.map(opt => (
                        <option key={opt.value} value={opt.value} disabled={opt.value === 'all' ? (formData.ageCategories.length >= ageCategoryOptions.length - 2) : formData.ageCategories.includes(opt.value)}>
                          {opt.label}{formData.ageCategories.includes(opt.value) && opt.value !== 'all' ? " (hozzáadva)" : ""}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {formData.ageCategories.length > 0 && (
                  <div style={{ paddingLeft: '200px', display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                    {formData.ageCategories.map(ageVal => (
                      <span key={ageVal} style={{ background: '#e9ecef', padding: '2px 8px', borderRadius: '10px', fontSize: '0.85em', display: 'flex', alignItems: 'center', border: '1px solid #dee2e6' }}>
                        {ageCategoryOptions.find(o => o.value === ageVal)?.label}
                        <button type="button" onClick={() => handleRemoveAgeCategory(ageVal)} style={{ marginLeft: '5px', border: 'none', color: '#dc3545', background: 'none', cursor: 'pointer', fontWeight: 'bold' }}>×</button>
                      </span>
                    ))}
                  </div>
                )}
              </div>

              <div style={formSectionGroupStyle}>
                <div style={sectionTitleStyle}>Dátumok</div>
                {formData.format === 'normal' && (
                  <div style={formRowStyle}>
                    <label htmlFor="competitionDate" style={inlineLabelStyle}>Verseny napja:</label>
                    <div style={{ flex: 1 }}><input type="date" id="competitionDate" name="competitionDate" value={formData.competitionDate} onChange={handleChange} style={inputStyle} /></div>
                  </div>
                )}
                <div style={formRowStyle}>
                  <label htmlFor="registrationDeadline" style={inlineLabelStyle}>Nevezési határidő:</label>
                  <div style={{ flex: 1 }}><input type="date" id="registrationDeadline" name="registrationDeadline" value={formData.registrationDeadline} onChange={handleChange} style={inputStyle} /></div>
                </div>
              </div>
            </div>
          </div>

          {/* JOBB OLDAL - LEÍRÁS KÁRTYA */}
          <div style={rightColumnStyle}>
            <div style={{ ...cardStyle, display: 'flex', flexDirection: 'column', height: '100%' }}>
              <label htmlFor="competitionDescription" style={labelStyle}>Verseny Leírása:</label>
              <textarea
                id="competitionDescription"
                name="competitionDescription"
                value={formData.competitionDescription}
                onChange={handleChange}
                style={{ ...descriptionTextAreaStyle, flex: 1, minHeight: '0' }}
                placeholder="Írd ide a verseny részletes leírását..."
              />
            </div>
          </div>
        </div>

        {/* --- 2. SOR: HELYSZÍN ÉS TÉRKÉP --- */}
        <div style={{ display: 'flex', flexDirection: 'row', gap: '2rem' }}>

          {/* BAL OLDAL - ALSÓ ADATOK */}
          <div style={leftColumnStyle}>
            <div style={cardStyle}>
              <div style={formSectionGroupStyle}>
                <div style={sectionTitleStyle}>Helyszín és Szervező</div>
                <div style={formRowStyle}>
                  <label htmlFor="location" style={inlineLabelStyle}>Helyszín (pontos cím):</label>
                  <div style={{ flex: 1 }}>
                    <input
                      ref={locationInputRef} // REF BEKÖTÉSE
                      type="text"
                      id="location"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                      style={inputStyle}
                      placeholder="Kezdd el gépelni a címet..."
                    />
                  </div>
                </div>
                <div style={formRowStyle}>
                  <label style={inlineLabelStyle}>GPS pozíció:</label>
                  <div style={{ display: 'flex', gap: '1rem', flex: 1 }}>
                    <input type="text" name="gpsLatitude" placeholder="Szélesség" value={formData.gpsLatitude} onChange={handleChange} style={{ ...inputStyle, width: '50%' }} />
                    <input type="text" name="gpsLongitude" placeholder="Hosszúság" value={formData.gpsLongitude} onChange={handleChange} style={{ ...inputStyle, width: '50%' }} />
                  </div>
                </div>
                <div style={formRowStyle}>
                  <label htmlFor="organizingClub" style={inlineLabelStyle}>Szervező egyesület:</label>
                  <div style={{ flex: 1 }}><input type="text" id="organizingClub" name="organizingClub" value={formData.organizingClub} onChange={handleChange} style={inputStyle} /></div>
                </div>
                <div style={formRowStyle}>
                  <div style={{ minWidth: '200px' }}></div>
                  <label style={{ ...checkboxLabelStyle, flex: 1 }}>
                    <input type="checkbox" name="inMISZCalendar" checked={formData.inMISZCalendar} onChange={handleChange} />
                    MISZ Naptárban szerepel
                  </label>
                </div>
              </div>

              <div style={formSectionGroupStyle}>
                <div style={sectionTitleStyle}>Étkezés</div>
                <div style={formRowStyle}>
                  <div style={{ minWidth: '200px' }}></div>
                  <label style={{ ...checkboxLabelStyle, flex: 1 }}>
                    <input type="checkbox" name="lunchAvailable" checked={formData.lunchAvailable} onChange={handleChange} />
                    Ebéd igényelhető
                  </label>
                </div>
              </div>

              <div style={formSectionGroupStyle}>
                <div style={sectionTitleStyle}>Technikai Részletek</div>
                <div style={formRowStyle}>
                  <label htmlFor="maxParticipants" style={inlineLabelStyle}>Max. résztvevők száma:</label>
                  <div style={{ flex: 1 }}><input type="text" id="maxParticipants" name="maxParticipants" value={formData.maxParticipants} onChange={handleNumericChange} style={inputStyle} /></div>
                </div>
                <div style={formRowStyle}>
                  <label htmlFor="numberOfTargets" style={inlineLabelStyle}>Célok száma:</label>
                  <div style={{ flex: 1 }}><input type="text" id="numberOfTargets" name="numberOfTargets" value={formData.numberOfTargets} onChange={handleChange} style={inputStyle} /></div>
                </div>
                <div style={formRowStyle}>
                  <label htmlFor="shotsPerTarget" style={inlineLabelStyle}>Célonkénti lövések:</label>
                  <div style={{ flex: 1 }}><input type="text" id="shotsPerTarget" name="shotsPerTarget" value={formData.shotsPerTarget} onChange={handleChange} style={inputStyle} /></div>
                </div>

                <div style={formRowStyle}>
                  <div style={{ minWidth: '200px' }}></div>
                  <label style={{ ...checkboxLabelStyle, flex: 1, color: '#b30000', fontWeight: 'bold' }}>
                    <input type="checkbox" name="crossbowSingleShot" checked={formData.crossbowSingleShot} onChange={handleChange} />
                    Számszeríj csak egy lövés
                  </label>
                </div>

                <div>
                  <label style={labelStyle}>Találati értékek kiválasztása:</label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #ddd' }}>
                    {['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', 'X'].map(val => (
                      <button key={val} type="button" onClick={() => toggleScoringValue(val)} style={scoreButtonStyle(formData.scoringValues.includes(val))}>{val}</button>
                    ))}
                    <button type="button" onClick={() => setShowCustomScoreModal(true)} style={{ ...scoreButtonStyle(false), backgroundColor: '#eee', color: '#b30000' }}><FiPlus size={20} /></button>
                  </div>
                </div>

                <div style={formRowStyle}>
                  <label htmlFor="tieBreakingRule" style={inlineLabelStyle}>Pontegyenlőség szabály:</label>
                  <div style={{ flex: 1 }}>
                    <select id="tieBreakingRule" name="tieBreakingRule" value={formData.tieBreakingRule} onChange={handleChange} style={inputStyle} required>
                      {tieBreakingOptions.map(option => (<option key={option.value} value={option.value}>{option.label}</option>))}
                    </select>
                  </div>
                </div>
              </div>

              <button type="submit" style={submitButtonStyle} disabled={isSubmitting}>
                {isSubmitting ? 'Mentés folyamatban...' : 'Módosítások mentése'}
              </button>
            </div>
          </div>

          {/* JOBB OLDAL - VALÓDI TÉRKÉP (A Helyszín mellé igazítva) */}
          <div style={rightColumnStyle}>
            <div style={{
              ...cardStyle,
              height: '550px',
              display: 'flex',
              flexDirection: 'column',
              padding: '10px'
            }}>
              <GoogleMapPicker
                lat={formData.gpsLatitude}
                lng={formData.gpsLongitude}
                onLocationChange={(lat, lng) => {
                  setFormData(prev => ({ ...prev, gpsLatitude: lat, gpsLongitude: lng }));
                }}
              />
              <p style={{ fontSize: '0.8rem', color: '#888', textAlign: 'center', marginTop: '5px' }}>
                Húzd a jelölőt a pontos helyszínre!
              </p>
            </div>
          </div>
        </div>

      </form>
    </div>
  );


      

};

export default EditCompetitionPage;

